import { PropsWithChildren, useRef } from 'react';
import styled from 'styled-components';
import { Box } from '@ardoq/layout';
import { colors, r8, shadowM } from '@ardoq/design-tokens';
import { useResizeObserver } from '@ardoq/hooks';

const SIZE_TRANSITION = '200ms ease';

const Surface = styled(Box)`
  overflow: hidden;
  background-color: ${colors.surfaceDefault};
  border-radius: ${r8};
  box-shadow: ${shadowM};
  transition:
    width ${SIZE_TRANSITION},
    height ${SIZE_TRANSITION};
`;

type AnimatedPopoverSurfaceProps = PropsWithChildren<{
  /** Target width (px). Animated when it changes between steps. */
  width: number;
}>;

/**
 * Popover surface that animates its width to the controlled `width` and its
 * height to fit the current content. Swapping the children animates the
 * transition, so a single popover can grow/shrink as its content changes.
 */
export const AnimatedPopoverSurface = ({
  width,
  children,
}: AnimatedPopoverSurfaceProps) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const { height } = useResizeObserver(contentRef);

  return (
    <Surface style={{ width, height }}>
      <div ref={contentRef} style={{ width }}>
        {children}
      </div>
    </Surface>
  );
};
